import $ from 'jquery';
import FareConditionAdvice from '../fare-condition-advice/fare-condition-advice';
import { initializePaymentSummary } from './payment-summary/payment-summary';

interface IAnimateParameters {
    targetPosition: number;
    duration: JQuery.Duration;
    complete?: (this: any) => void;
}

// Tell browser not to remember scroll position on history navigation
// Because we want users to start by seeing wizard steps firsts
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

export const StickySummary = () => {
    initializePaymentSummary();
    const stickyElement = document.getElementById('sticky-panel') as HTMLDivElement;
    const headerElement = document.getElementById('header') as HTMLDivElement;
    const offsetPosition = headerElement.clientHeight;

    const applySticky = () => {
        if (window.pageYOffset > offsetPosition) {
            stickyElement.classList.add('sticky');
        } else {
            stickyElement.classList.remove('sticky');
        }
    };

    window.onscroll = applySticky;

};

export const InitializeMagnificPopup = () => {
    $('body').magnificPopup({
        delegate: '.js-popup-trigger',
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        mainClass: 'mfp-fade',
        midClick: true,
    });
};

export const InitializeFareConditionAdvice = () => {
    new FareConditionAdvice().initializePopup(
        '[data-action="show-fare-condition-advice"]',
        '.fare-condition-advice-details .button-bar .btn, .fare-condition-advice-remark__more-info',
    );
};

export const InitializePaymentInstallments = () => {
    if (!window['LiveChatWidget']) { // payment installments requires live chat functionality
        return;
    }

    $('.payment-installments-widget')
        .show()
        .find('a[data-action="show-payment-installments-chat"]')
        .on('click', event => {
            event.preventDefault();
            window['LiveChatWidget'].call('maximize');
        })
};

export const InitializeFlightDetails = () => {
    $('#flight-details-toggle').on('change', event => {
        const target = event.currentTarget as HTMLInputElement;
        const $detailsContainers = $('.detailscontainer');

        $detailsContainers.toArray().forEach(el => {
            const elHeight = $(el).outerHeight(true) || 0;
            const property = target.checked ? elHeight : '0';
            $(el).parent('.itemdetails').css('max-height', property);
        });

    });

    $('.flightlist').on('click', () => {
        let detailsToggle = $('#flight-details-toggle');
        //Expand the flight details panel only when it is collapsed
        if (!detailsToggle.is(':checked')) {
            detailsToggle.prop("checked", true);
            detailsToggle.trigger('change');
        }
    });
};

export const ScrollToWizardSteps = () => {
    const targetElement = $('[data-scroll-target]') ?? $('.wizard-step-list:first-child');
    if (targetElement) {
        const offset = targetElement.offset();

        if (offset) {
            scrollTo({
                targetPosition: offset ? offset.top - 40 : 0,
                duration: 600,
                complete: $.noop,
            });
        }
    }
};

export const ScrollToError = (errorCallback?: () => void) => {
    /**
     * setTimeout() is to wait for Envoy client-side custom validator to finish executing,
     * otherwise, we won't find any visible error elements.
     */
    window.setTimeout(() => {
        const targetElement = getVisibleErrorElements();

        if (targetElement.length > 0) {
            if (errorCallback) {
                errorCallback();
            }
            const offset = targetElement.first().offset();

            scrollTo({
                targetPosition: offset ? offset.top - 100 : 0,
                duration: 400,
                complete: targetElement[0].className === 'validation-error' ?
                    () => targetElement.closest('.form-group').find('.validation-field').trigger('focus') :
                    $.noop,
            });
        }
    }, 500);
};

export const ScrollToActionablePosition = () => {

    //If super fare is not yet selected, dont scroll
    if (hasSuperFareUnchecked()) {
        return;
    }

    if (hasVisibleErrorElements()) {
        ScrollToError();
        return;
    }
    
    ScrollToWizardSteps();
};

const getVisibleErrorElements = () => $('.validation-error:not(:empty):visible:first, .validation-error-summary:not(:empty):visible:first');

const hasVisibleErrorElements = () => getVisibleErrorElements().length > 0;

export const hasSuperFareUnchecked = () => $('input[name="superfare"]:not(:checked)').length == 2;

const scrollTo = (animateParams: IAnimateParameters) => {
    $('html, body').stop().animate({
        scrollTop: animateParams.targetPosition,
    }, animateParams.duration, 'swing', animateParams.complete);
};
